/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Magiclinkcheckemail3Inputs */

const zh_auth_magiclinkcheckemail3 = /** @type {(inputs: Auth_Magiclinkcheckemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们已向您的邮箱发送了登录链接，请查收并点击链接完成登录。`)
};

const en_auth_magiclinkcheckemail3 = /** @type {(inputs: Auth_Magiclinkcheckemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've sent a magic link to your email. Check your inbox and click the link to sign in.`)
};

const es_auth_magiclinkcheckemail3 = /** @type {(inputs: Auth_Magiclinkcheckemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos enviado un enlace mágico a tu correo. Revisa tu bandeja de entrada y haz clic en el enlace para iniciar sesión.`)
};

/**
* | output |
* | --- |
* | "We've sent a magic link to your email. Check your inbox and click the link to sign in." |
*
* @param {Auth_Magiclinkcheckemail3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_magiclinkcheckemail3 = /** @type {((inputs?: Auth_Magiclinkcheckemail3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Magiclinkcheckemail3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_magiclinkcheckemail3(inputs)
	if (locale === "en") return en_auth_magiclinkcheckemail3(inputs)
	return es_auth_magiclinkcheckemail3(inputs)
});
export { auth_magiclinkcheckemail3 as "auth_magicLinkCheckEmail" }